import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

/** Stroke recreation of PrimeIcons `pi-wallet`. */
export const GLM_WALLET: GlameraIconDefinition = {
  name: 'wallet',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-wallet-flap" pathLength="1" d="M5 9 17 3.8a1.1 1.1 0 0 1 1.2 1.1V8.5"></path>
    <rect class="glm-wallet-body" pathLength="1" x="3.5" y="8" width="17" height="12.5" rx="1.75"></rect>
    <circle class="glm-wallet-snap" cx="16.5" cy="14" r="1.25" fill="currentColor" stroke="none"></circle>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-wallet-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './wallet.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class WalletIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_WALLET;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
